import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({ location, context }) => {
    if (!context.user) {
      const redirectUrl = location.href !== '/' ? location.href : undefined;
      throw redirect({ to: '/log-in', search: { redirect: redirectUrl } });
    }
  },
});
